<script>
import bem from '@/utils/bem';
import notificationWithIcon from '@/utils/notification';
import getContentBlock from '@/pages/promotions/promoTemplates/editDesktopOrMobileCssStyle/Get-content-block.vue';
import createDebounce from '@/utils/debounce';
import ArrowIcon from '@/components/svg/arrowIcon/Arrow-icon.vue';
import { ColorPicker } from 'vue3-colorpicker';
import { mapActions } from 'vuex';

const desktopStyles = bem('promo-banner');
const mobileStyles = bem('promo-banner-mobile');

const STYLES_NO_PIXELS = ['color', 'fontWeight'];

export default {
  components: { ColorPicker, ArrowIcon, getContentBlock },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    promoTemplateChecked: {
      type: Object,
      required: true,
    },
    typePreview: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      title: '',
      b: this.typePreview ? mobileStyles : desktopStyles,
      template: {
        name: '',
        css: {
          styleSteps: [],
        },
        banner: {
          text: '',
          mobileDropDownText: '',
          dropDownText: '',
          countDown: true,
          countDownText: '',
        },
        steps: [],
      },
      isOpen: false,
      isEveryHide: null,
      windowWidth: 1920,
      firstStep: null,
      selectedStep: null,
      styleField: null,
      step: {
        // desktopImage: '',
        // mobileImage: '',
        // title: '',
        // subtitle: '',
        // body: '',
        // buttonText: '',
        // disclaimerText: '',
      },
      styleStep: {
        titleStyles: '',
        subtitleStyles: '',
        bodyStyles: '',
        disclaimerStyles: '',
        titleMobileStyles: '',
        subtitleMobileStyles: '',
        bodyMobileStyles: '',
        disclaimerMobileStyles: '',
      },
      valuesStyleStep: {
        marginLeft: 0,
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        fontSize: 0,
        fontWeight: 0,
        lineHeight: 0,
        color: '#000000',
        width: 0,
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
      },
    };
  },
  methods: {
    ...mapActions({
      changeStyleTemplateAction: 'promotions/changeStyleTemplate',
    }),
    createDebounce,
    notificationWithIcon,
    hideModal() {
      this.$emit('update:show', false);
    },
    getStyleValue(max, value) {
      return ((value / max) * 100).toFixed(4);
    },
    resizeWindow() {
      createDebounce(() => {
        this.windowWidth = window.innerWidth;
      }, 300);
    },
    responsiveStyle(style) {
      if (this.windowWidth > 1024 && this.windowWidth <= 1920) {
        return style && Object.keys(style).length && Object.keys(style).reduce((acc, key) => {
          if (!STYLES_NO_PIXELS.includes(key)) {
            return {
              ...acc,
              [key]: `${this.getStyleValue(1920, style[key])}vw`,
            };
          }
          return {
            ...acc,
            [key]: style[key],
          };
        }, {});
      }
      return style;
    },
    onSelectCssEdit(field) {
      this.styleField = field;
    },
    openBanner() {
      this.isOpen = !this.isOpen;
    },
    getSelectedStyle() {
      if (this.template.id && this.template.css.styleSteps[this.selectedStep]) {
        const style = this.template.css.styleSteps[this.selectedStep];
        return style[this.styleField] || [];
      }
      return {};
    },
    newStyleStep(value, field) {
      const selectedStyles = this.getSelectedStyle();
      if ((this.template.css.styleSteps && this.template.css.styleSteps.length === 0)
        || !this.template.css.styleSteps[this.selectedStep]) {
        return [
          ...this.template.css.styleSteps, {
            [this.styleField]: {
              [field]: value,
            },
          },
        ];
      }
      return this.template.css.styleSteps.map((item, index) => {
        if (index === this.selectedStep) {
          return {
            ...item,
            [this.styleField]: {
              ...selectedStyles,
              [field]: value,
            },
          };
        }
        return item;
      });
    },
    changeStyle(value, field) {
      this.template = {
        ...this.template,
        css: {
          styleSteps: [
            ...this.newStyleStep(value, field),
          ],
        },
      };
    },
    onSubmit() {
      const payload = {
        id: this.template.id,
        name: this.template.name,
        dateCreated: this.template.dateCreated,
        css: this.template.css,
        isDeleted: this.template.isDeleted,
        isActive: this.template.isActive,
      };
      this.changeStyleTemplateAction(payload);
      this.hideModal();
    },
    showEditableElement() {
      let element = '';
      switch (this.styleField) {
        case 'titleStyles':
          element = 'title';
          break;
        case 'subtitleStyles':
          element = 'subtitle';
          break;
        case 'bodyStyles':
          element = 'body';
          break;
        case 'disclaimerStyles':
          element = 'disclaimer';
          break;
        case 'titleMobileStyles':
          element = 'mobile title';
          break;
        case 'subtitleMobileStyles':
          element = 'mobile subtitle';
          break;
        case 'bodyMobileStyles':
          element = 'mobile body';
          break;
        case 'disclaimerMobileStyles':
          element = 'mobile disclaimer';
          break;
        default:
          break;
      }
      return element;
    },
  },
  created() {
    window.addEventListener('resize', this.resizeWindow);
  },
  mounted() {
    if (this.typePreview) {
      this.title = 'Mobile banner.';
    } else {
      this.title = 'Desktop banner.';
    }
    this.template = { ...JSON.parse(JSON.stringify(this.promoTemplateChecked))[0] };
    this.template = {
      ...this.template,
      steps: this.template.steps.sort((first, second) => first.id - second.id),
    };
    if (!this.template.css.styleSteps) {
      this.template = {
        ...this.template,
        css: {
          styleSteps: [],
        },
      };
    }
    this.isEveryHide = this.template.steps.every(({ hideStep }) => hideStep);
    this.firstStep = this.template.steps && this.template.steps.length
      ? this.template.steps.findIndex(({ hideStep }) => !hideStep)
      : null;
    this.selectedStep = this.firstStep === -1 ? null : this.firstStep;
    this.step = { ...this.template.steps[this.selectedStep] };
    this.styleStep = this.template.css.styleSteps && this.template.css.styleSteps.length
      ? { ...this.template.css.styleSteps[this.selectedStep] } : {};
  },
  unmounted() {
    window.removeEventListener('resize', this.resizeWindow);
  },
  watch: {
    template: {
      handler(newV) {
        this.step = { ...this.template.steps[this.selectedStep] };
        this.styleStep = newV.css.styleSteps && newV.css.styleSteps.length
          ? { ...newV.css.styleSteps[this.selectedStep] } : {};
      },
      deep: true,
    },
    styleField() {
      this.valuesStyleStep = this.getSelectedStyle();
      if (!Object.values(this.valuesStyleStep)) {
        this.valuesStyleStep = {
          marginLeft: 0,
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          fontSize: 0,
          fontWeight: 0,
          lineHeight: 0,
          color: '#000000',
          width: 0,
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
        };
      }
    },
    valuesStyleStep: {
      handler() {
        this.template = {
          ...this.template,
          css: {
            styleSteps: this.template.css.styleSteps.map((item, index) => {
              if (index === this.selectedStep) {
                return {
                  ...item,
                  [this.styleField]: this.valuesStyleStep,
                };
              }
              return item;
            }),
          },
        };
      },
      deep: true,
    },
  },
};
</script>

<template>
  <a-modal
    :open="show"
    :footer="null"
    @cancel="hideModal"
    :width="typePreview ? '850px' : '90%'"
  >
    <div class="wrapper">
      <div :class="typePreview ? 'left-side-mobile' : 'left-side'">
        <h1 class="text-2xl font-bold mb-2">
          {{ title }}
        </h1>
        <div :class="b('')">
          <div
            :class="b('top-block')"
            id="promo-banner"
          >
            <div :class="b('container')">
              <div :class="b('top-block-content')">
                <div :class="b('top-text', {'hidden-mobile': true })">
                  {{ template.banner.text }}
                </div>
                <div :class="b('top-text', {'hidden-desktop': true })">
                  {{ template.banner.mobileDropDownText }}
                </div>
              </div>
              <div
                v-if="!isEveryHide"
                :class="b('learn-more-block')"
              >
                <button
                  :class="b('learn-more')"
                  type="button"
                  @click="openBanner(!isOpen)"
                >
                  <span v-if="!typePreview" :class="b('btn-text')">
                    {{ isOpen ? 'Close' : template.banner.dropDownText }}
                  </span>
                  <div :class="b('close-btn-icon')" v-if="isOpen" />
                  <div :class="b('arrow-wrap')" v-else>
                    <arrow-icon
                      :name="b('arrow', { open: isOpen })"
                      stroke="#fff"
                    />
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div :class="b('bottom-block')" v-if="isOpen">
            <div :class="b('background-block')">
              <get-content-block
                :checked-step="step"
                :style-step="styleStep"
                v-if="!typePreview"
                :responsive-style="responsiveStyle"
                :on-select-css-edit="onSelectCssEdit"
                :type-preview="typePreview"
                v-model:selected-step="selectedStep"
              />
              <span
                v-if="step.title && typePreview"
                :class="b('step-title')"
                role="button"
                tabindex="-1"
                @click="onSelectCssEdit('titleMobileStyles')"
                @keydown="onSelectCssEdit('titleMobileStyles')"
                :style="responsiveStyle(styleStep.titleMobileStyles)"
              >
                {{ step.title }}
              </span>
              <img
                :class="b('image-block')"
                :src="typePreview ? step.mobileImage : step.desktopImage"
                alt="img"
              />
              <get-content-block
                :checked-step="step"
                :style-step="styleStep"
                v-if="typePreview"
                :responsive-style="responsiveStyle"
                :on-select-css-edit="onSelectCssEdit"
                :type-preview="typePreview"
                v-model:selected-step="selectedStep"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="right-side">
        <div class="top-block">
          <h1 class="text-2xl font-bold mb-2">
            Style CSS:
          </h1>
          <div class="form">
            <div class="row">
              <div class="column">
                <h4>Margin left:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.marginLeft"
                  @change="changeStyle(valuesStyleStep.marginLeft, 'marginLeft')"
                />
              </div>
              <div class="column">
                <h4>Margin right:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.marginRight"
                  @change="changeStyle(valuesStyleStep.marginRight, 'marginRight')"
                />
              </div>
              <div class="column">
                <h4>Margin top:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.marginTop"
                  @change="changeStyle(valuesStyleStep.marginTop, 'marginTop')"
                />
              </div>
              <div class="column">
                <h4>Margin bottom:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.marginBottom"
                  @change="changeStyle(valuesStyleStep.marginBottom, 'marginBottom')"
                />
              </div>
            </div>
            <div class="row">
              <div class="column">
                <h4>Padding left:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.paddingLeft"
                  @change="changeStyle(valuesStyleStep.paddingLeft, 'paddingLeft')"
                />
              </div>
              <div class="column">
                <h4>Padding right:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.paddingRight"
                  @change="changeStyle(valuesStyleStep.paddingRight, 'paddingRight')"
                />
              </div>
              <div class="column">
                <h4>Padding top:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.paddingTop"
                  @change="changeStyle(valuesStyleStep.paddingTop, 'paddingTop')"
                />
              </div>
              <div class="column">
                <h4>Padding bottom:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.paddingBottom"
                  @change="changeStyle(valuesStyleStep.paddingBottom, 'paddingBottom')"
                />
              </div>
            </div>
            <div class="row">
              <div class="column">
                <h4>Font size:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.fontSize"
                  @change="changeStyle(valuesStyleStep.fontSize, 'fontSize')"
                />
              </div>
              <div class="column">
                <h4>Font weight:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.fontWeight"
                  @change="changeStyle(valuesStyleStep.fontWeight, 'fontWeight')"
                />
              </div>
              <div class="column">
                <h4>Line height:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.lineHeight"
                  @change="changeStyle(valuesStyleStep.lineHeight, 'lineHeight')"
                />
              </div>
              <div class="column">
                <h4>Width:</h4>
                <a-input-number
                  v-model:value="valuesStyleStep.width"
                  @change="changeStyle(valuesStyleStep.width, 'width')"
                />
              </div>
            </div>
            <div class="row">
              <div class="column">
                <h4>Color:</h4>
                <color-picker v-model:pureColor="valuesStyleStep.color" />
              </div>
            </div>
            <div class="row element" v-if="styleField">
              You are edit style for <b>{{ showEditableElement() }}</b>.
            </div>
            <div class="row element" v-else>
              Click element for edit his style.
            </div>
          </div>
        </div>
        <div class="bottom-block">
          <a-button type="primary" @click="onSubmit">Save</a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<style scoped lang="scss" src="./styles.scss">

</style>
